import React, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from '../../styles.module.scss';
import MobilePitchPlayer from '../MobilePitchPlayer/MobilePitchPlayer';
import { buildMobileVerticalRows } from '../../constants';

const MobileLineupPitch = forwardRef(function MobileLineupPitch(
  { players, isHome, formationStr, formationFallback, backgroundImageUrl },
  ref,
) {
  const rows = buildMobileVerticalRows(players, formationStr, formationFallback);

  return (
    <div ref={ref} className={styles['wca-lineaciones__pitch-mobile-wrap']}>
      <div
        className={styles['wca-lineaciones__pitch-mobile']}
        style={backgroundImageUrl ? { backgroundImage: `url(${backgroundImageUrl})` } : undefined}
      >
        <div className={styles['wca-lineaciones__pitch-mobile-field']} aria-hidden="true">
          <div className={styles['wca-lineaciones__pitch-mobile-box-outer']} />
          <div className={styles['wca-lineaciones__pitch-mobile-box-inner']} />
          <div className={styles['wca-lineaciones__pitch-mobile-semicircle']}>
            <div className={styles['wca-lineaciones__pitch-mobile-semicircle-arc']} />
          </div>
        </div>
        <div className={styles['wca-lineaciones__pitch-mobile-rows']}>
          {rows.map((row, ri) => (
            <div
              key={`row-${ri}`}
              className={classNames(
                styles['wca-lineaciones__pitch-mobile-row'],
                styles[`wca-lineaciones__pitch-mobile-row--n${row.length}`],
                row.length === 1 ? styles['wca-lineaciones__pitch-mobile-row--striker'] : '',
                ri === rows.length - 1 ? styles['wca-lineaciones__pitch-mobile-row--goal-line'] : '',
              )}
            >
              {row.map((p, j) => (
                <MobilePitchPlayer
                  key={`m-${ri}-${j}-${p.name || j}`}
                  name={p.name}
                  photo={p.photo}
                  yellow={p.yellow}
                  red={p.red}
                  redCard2y={p.redCard2y}
                  goal={p.goal}
                  goalCount={p.goalCount}
                  subOut={p.subOut}
                  isHome={isHome}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default MobileLineupPitch;
